import * as React from 'react'
import { CompanyIcon } from '@/app/features/icons/Company'
import { CompanyMeta } from './CompanyMeta'
// import { useCompanyDetailsQuery } from '@/lib/api/company/useCompanyDetailsQuery'
import { useParams } from 'react-router-dom'
import { useQueryCompanies } from '../../query-client'

export const CompanyMetaContainer = () => {
  const { companyId } = useParams<{ companyId: string }>()

  const companiesQuery = useQueryCompanies({ includeDeleted: false })

  const companiesOptions = companiesQuery.data?.length
    ? companiesQuery.data.map((company) => ({
        label: company.invoiceCompanyName || company.companyName || '',
        value: company.id,
        icon: CompanyIcon,
      }))
    : []

  const selectedCompany = React.useMemo(() => {
    return companiesOptions.find((c) => c.value == companyId) || null
  }, [companyId, companiesOptions])

  //   const { data } = useCompanyDetailsQuery({ companyId })

  if (selectedCompany) {
    return (
      <CompanyMeta
        id={companyId || undefined}
        name={selectedCompany?.label || undefined}
      />
    )
  }

  return null
}
